const EXPERIENCE_TO_NEXT_LEVELUP = 6

export default function getLevelStatus(score = 0) {
    return {
        "level": Math.floor(score / EXPERIENCE_TO_NEXT_LEVELUP) + 1,
        "experience": score % EXPERIENCE_TO_NEXT_LEVELUP,
        "maxexperience": EXPERIENCE_TO_NEXT_LEVELUP,
    }
}
